export function canonicalNameKey(name) {
    return name.normalize("NFKC").toLowerCase();
}
